// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const FormStyling = ((($) => {
  function init() {
    $('select').styler();

    $('input[type="radio"]').styler();

    $('.label-animate').on('focusin', function() {
      $(this).parent().find('.label').addClass('active');
    });

    $('.label-animate').on('focusout', function() {
      if (!this.value) {
        $(this).parent().find('.label').removeClass('active');
      }
    });
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default FormStyling;



// WEBPACK FOOTER //
// ./src/static/js/modules/form-styling.js